import React from 'react';
import { KBBlock } from '../../../types';
import { renderInline } from '../utils/renderInline';

interface Props {
  block: KBBlock;
  isEditing: boolean;
  onChange: (updates: Partial<KBBlock>) => void;
  onFinish: () => void;
}

const sizes: Record<number, string> = {
  1: 'text-4xl font-bold text-gray-900 leading-tight',
  2: 'text-3xl font-bold text-gray-800 leading-snug',
  3: 'text-2xl font-semibold text-gray-800',
};

const HeadingBlock: React.FC<Props> = ({ block, isEditing, onChange, onFinish }) => {
  const level = block.data?.level ?? 1;
  const Tag = `h${level}` as 'h1' | 'h2' | 'h3';

  if (isEditing) {
    return (
      <div className="flex items-start gap-2">
        <select
          value={level}
          onChange={(e) => onChange({ data: { ...block.data, level: Number(e.target.value) } })}
          className="mt-1 text-xs border border-gray-300 rounded px-1 py-0.5 text-gray-600 bg-white"
        >
          <option value={1}>H1</option>
          <option value={2}>H2</option>
          <option value={3}>H3</option>
        </select>
        <input
          autoFocus
          type="text"
          value={block.content}
          placeholder={`Heading ${level}`}
          onChange={(e) => onChange({ content: e.target.value })}
          onBlur={onFinish}
          onKeyDown={(e) => e.key === 'Escape' && onFinish()}
          className={`flex-1 bg-transparent border-none outline-none ${sizes[level]} placeholder-gray-300 w-full`}
        />
      </div>
    );
  }

  return (
    <Tag className={`${sizes[level]} ${!block.content ? 'text-gray-300' : ''}`}>
      {block.content ? renderInline(block.content) : `Heading ${level}`}
    </Tag>
  );
};

export default HeadingBlock;
